module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/village//result-vs.png?v=ee56ca0f";